import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import DesignCard from '../../../../shared/components/DesignCard';
import { StyledEntry } from './StyledEntries';

export interface Props {
    src: string;
    alt: string;
    attribution?: React.ReactNode;
    index: number;
    parallax?: boolean;
}

const yMap = [
    [-30, 60],
    [-5, 20],
    [-50, -20],
    [-30, 30],
    [-45, 35],
    [-50, 20],
    [-30, 40],
    [-15, 35],
    [-10, 40],
    [-5, 20],
];

export default function Entry({ src, alt, attribution, index, parallax = false }: Props) {
    return (
        <StyledEntry index={index}>
            <Parallax
                translateY={[yMap[index][0], yMap[index][1]]}
                disabled={!parallax}
                style={{ height: '100%' }}
            >
                <DesignCard
                    src={src}
                    alt={alt}
                    width={287}
                    height={287}
                    variations={['medium-shadow']}
                    attribution={attribution}
                ></DesignCard>
            </Parallax>
        </StyledEntry>
    );
}
